// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18xxY","content":"styles_content__1xG_7"};